import Typography from '@mui/material/Typography';
import React from 'react';

import { useTranslator } from '@/hooks/useTranslator';
import { SelectItem } from '@/types/fields';

interface Props {
  readonly item: SelectItem<string | number>;
}

export const DefaultSelectItem: React.FC<Props> = (props: Props): React.ReactElement => {
  const { item } = props;
  const tr = useTranslator();

  return (
    <Typography fontSize={16} fontWeight={400} lineHeight="20px">
      {tr(item.label)}
    </Typography>
  );
};
